// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorBoundary_wrapper__1gWfC","error":"ErrorBoundary_error__1FE13","headerOverrides":"ErrorBoundary_headerOverrides__1D1uF","email":"ErrorBoundary_email__1x5IW"};